import script from "./ToggleStatusField.vue?vue&type=script&setup=true&lang=js"
export * from "./ToggleStatusField.vue?vue&type=script&setup=true&lang=js"

import "./ToggleStatusField.vue?vue&type=style&index=0&id=6e6b5f68&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e6b5f68"]])

export default __exports__